import { Box, Container, Grid, Paper, Typography } from '@material-ui/core';
import { ComplaintStatusCheck } from 'Components/Api/ComplaintsAPI';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import HOCLoader from 'Components/Loader/HOCLoader';
import { LOGOUT } from 'ConstComponents';
import { Form, Formik } from 'formik';
import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Divider from '@material-ui/core/Divider';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import BharatConnect_LOGO from 'Assets/BBPS/BBPS-Horizontal-06.png';
const CustomContainer = HOCLoader(Container);

export const ComplaintStatus = () => {
    const history = useHistory();
    const formRef = useRef();
    const [responseMessage, setResponseMessage] = useState('');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [IsDetailsList, setDetailsList] = useState([]);
    const [IsDetails, setDetails] = useState(false);
    const [formObj, setFormObj] = useState({
        TransactionMasterID: 0,
        MobileNumber: ''
    });

    const validationSchema = Yup.object({
        MobileNumber: Yup.string()
            .required('Mobile Number is required.')
            .matches(/^[0-9]{10}$/, 'Mobile Number must be 10 digits.'),
        TransactionMasterID: Yup.string().required(
            'Transaction ID is required.'
        )
    });

    useEffect(() => {
        setLoadingOpen(true);

        setLoadingOpen(false);
    }, []);

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setSubmitting(false);
        setDetails(false);
        setDetailsList([]);
        setResponseMessage('');
        let requestObj = {
            TransactionMasterID: values.TransactionMasterID,
            MobileNumber: values.MobileNumber
        };
        setLoadingOpen(true);
        const response = await ComplaintStatusCheck(JSON.stringify(requestObj));
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            setDetails(false);
            return;
        }

        setIsError(true);
        setResponseMessage(response.data);
        resetForm();
    };

    const reset = () => {
        setResponseMessage('');
        setFormObj({
            TransactionMasterID: 0,
            MobileNumber: ''
        });
    };

    const TransferForm = ({ values, errors, setFieldValue }) => {
        return (
            <>
                <Grid
                    item
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                        textAlign: 'right',
                        marginTop: '5px',
                        marginRight: '5px'
                    }}
                >
                    <img
                        src={BharatConnect_LOGO}
                        alt="BharatConnect Logo"
                        style={{ maxHeight: '50px' }}
                    />
                </Grid>
                <Paper style={{ padding: '30px' }}>
                    <Grid container>
                        <Grid item sm={12} md={12} lg={12}>
                            <Grid
                                container
                                spacing={2}
                                style={{ padding: '10px' }}
                            >
                                <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
                                    <Typography
                                        variant="h4"
                                        component="h1"
                                        gutterBottom
                                    >
                                        Complaint Status
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                    <PrimaryButton
                                        type="button"
                                        title="Register complaint"
                                        size="small"
                                        onClick={() =>
                                            history.push('/RegisterComplaint')
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <Divider />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <CustomContainer
                                isLoading={loadingOpen}
                                isError={isError}
                                alertMessage={responseMessage}
                                severity={severity}
                                onCloseCallback={(alertState) => {
                                    setIsError(alertState);
                                }}
                            >
                                <Form>
                                    <Grid
                                        spacing={5}
                                        container
                                        style={{
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <Grid
                                            item
                                            xs={4}
                                            sm={4}
                                            md={4}
                                            lg={4}
                                            xl={4}
                                        >
                                            <Grid
                                                container
                                                spacing={2}
                                                sx={{
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                >
                                                    <MaterialNumberField
                                                        label="Mobile Number"
                                                        name="MobileNumber"
                                                        type="text"
                                                        length={10}
                                                        title="Mobile Number"
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                >
                                                    <MaterialTextField
                                                        label="BBPS Transaction ID"
                                                        name="TransactionMasterID"
                                                        type="text"
                                                        length={150}
                                                        title="BBPS TransactionID"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Divider
                                                variant="middle"
                                                className="rechdevider"
                                            />

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                spacing={2}
                                                container
                                            >
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        item
                                                        sm={12}
                                                        md={12}
                                                        lg={6}
                                                        xl={6}
                                                    >
                                                        <PrimaryButton
                                                            type="submit"
                                                            title="Submit"
                                                            sx={{
                                                                marginTop: 3,
                                                                height: '50px',
                                                                textTransform:
                                                                    'none',
                                                                paddingX:
                                                                    '50px',
                                                                borderRadius:
                                                                    '4px'
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        sm={12}
                                                        md={12}
                                                        lg={6}
                                                        xl={6}
                                                    >
                                                        <SecondaryButton
                                                            type="reset"
                                                            variant="contained"
                                                            color="secondary"
                                                            title="Reset"
                                                            sx={{
                                                                marginTop: 3,
                                                                height: '50px',
                                                                textTransform:
                                                                    'none',
                                                                paddingX:
                                                                    '50px',
                                                                borderRadius:
                                                                    '4px'
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Form>
                            </CustomContainer>
                        </Grid>
                    </Grid>
                </Paper>
                {IsDetails && (
                    <Paper style={{ padding: '30px' }}>
                        <Grid item xs={12}>
                            <Typography
                                style={{
                                    borderBottom: '1px solid #ccc',
                                    fontSize: '16px',
                                    fontWeight: '600'
                                }}
                            >
                                Complaint status
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Box
                                style={{
                                    background: '#f1f1f1',
                                    padding: '16px',
                                    borderRadius: '10px'
                                }}
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <h2 style={{ fontSize: '16px' }}>
                                            FirmName :{' '}
                                            <span
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {IsDetailsList.FirmName}
                                            </span>
                                        </h2>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <h2 style={{ fontSize: '16px' }}>
                                            Transaction Date & Time :{' '}
                                            <span
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {IsDetailsList.TransactionDate}
                                            </span>
                                        </h2>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <h2 style={{ fontSize: '16px' }}>
                                            Complaint Date & Time :{' '}
                                            <span
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {IsDetailsList.DOC}
                                            </span>
                                        </h2>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <h2 style={{ fontSize: '16px' }}>
                                            Service :{' '}
                                            <span
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {IsDetailsList.Service}
                                            </span>
                                        </h2>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <h2 style={{ fontSize: '16px' }}>
                                            Operator :{' '}
                                            <span
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {IsDetailsList.Operator}
                                            </span>
                                        </h2>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <h2 style={{ fontSize: '16px' }}>
                                            Transaction request ID :{' '}
                                            <span
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {
                                                    IsDetailsList.ProviderRequestID
                                                }
                                            </span>
                                        </h2>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <h2 style={{ fontSize: '16px' }}>
                                            Mobile number :{' '}
                                            <span
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {IsDetailsList.ConsumerNumber}
                                            </span>
                                        </h2>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <h2 style={{ fontSize: '16px' }}>
                                            Amount :{' '}
                                            <span
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {IsDetailsList.Amount}
                                            </span>
                                        </h2>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <h2 style={{ fontSize: '16px' }}>
                                            Transaction status :{' '}
                                            <span
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {IsDetailsList.OldStatus}
                                            </span>
                                        </h2>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <h2 style={{ fontSize: '16px' }}>
                                            Complaint type :{' '}
                                            <span
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                Transaction
                                            </span>
                                        </h2>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <h2 style={{ fontSize: '16px' }}>
                                            Complaint reason :{' '}
                                            <span
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {IsDetailsList.ComplaintReason}
                                            </span>
                                        </h2>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <h2 style={{ fontSize: '16px' }}>
                                            Complaint remark :{' '}
                                            <span
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {IsDetailsList.CustomerRemark}
                                            </span>
                                        </h2>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <h2 style={{ fontSize: '16px' }}>
                                            Complaint status :{' '}
                                            <span
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {IsDetailsList.ComplaintStatus}
                                            </span>
                                        </h2>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <h2 style={{ fontSize: '16px' }}>
                                            Admin remark :{' '}
                                            <span
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {IsDetailsList.AdminRemark}
                                            </span>
                                        </h2>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Paper>
                )}
            </>
        );
    };

    return (
        <Formik
            innerRef={formRef}
            enableReinitialize={true}
            initialValues={formObj}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            resetForm={formObj}
        >
            {TransferForm}
        </Formik>
    );
};
